<template>
  <div class="layout-navbottom-clock">
    <div class="ele-botnav-clock">
      <div v-show="clockSelected"
           @click="change(true)">
        <img src="../../../assets/images/icon-clocknav-nac.png"
             class="icon-botnav-clock">
        <div class="font-bottomnav-clock nac-bottomnav-clock">考勤</div>
      </div>
      <div v-show="!clockSelected"
           @click="change(true)">
        <img src="../../../assets/images/icon-clocknav.png"
             class="icon-botnav-clock">
        <div class="font-bottomnav-clock">考勤</div>
      </div>
    </div>
    <div class="ele-botnav-clock">
      <div v-show="clockSelected"
           @click="change(false)">
        <img src="../../../assets/images/icon-totalnav.png"
             class="icon-botnav-clock">
        <div class="font-bottomnav-clock ">统计</div>
      </div>
      <div v-show="!clockSelected"
           @click="change(false)">
        <img src="../../../assets/images/icon-totalnav-nac.png"
             class="icon-botnav-clock">
        <div class="font-bottomnav-clock nac-bottomnav-clock">统计</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckInBottomFunc',
  data() {
    return {
      clockSelected: true, //打卡选中
    }
  },
  methods: {
    change(type) {
      this.clockSelected = type
      this.$bus.$emit('setSelected',type)
    },
  },
}
</script>

<style scoped>
</style>